module.exports = __webpack_public_path__ + "img/individual-subscriber-agreement.0d71a65d.svg";